import { useState, useEffect, useRef } from "react";
import { Container, Col, Form } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import { styled, withStyles } from "@mui/styles";
// import { Toast } from "primereact/toast";
import { toast } from "react-toastify";

import "./createEvent.css";
import { getRequest, postRequest } from "../../../actions/Handler";
import SummaryInfo from "../../../components/modal/summaryInfo/summaryInfo";


export default function CreateEvent({
  showPopup,
  updateModalState,
  currentPage,
}: any) {
  const [test, setTest] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [inputValues, setInputValue] = useState<any>({
    procedureId: "",
    eventType: "",
    facility: "",
    eventDate: undefined,
    patientInvolved: "",
    provider: "",
    patientMRN: "",
    patientFirstName: "",
    patientLastName: "",
    event: "",
    classify: "",
    reflect: "",
    userId: null,
    attachment: {
      id: 0,
      attachment: "",
    },
  });
  const navigate = useNavigate();
  const [errValues, setErrValues] = useState({
    procedureId: "",
    eventType: "",
    facility: "",
    eventDate: "",
    patientInvolved: "",
  });
  const [eventTypeOptions, setEventTypeOptions] = useState([]);
  const [patientInvolvedOptions, setPatientInvolvedOptions] = useState([]);
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [disable, setDisable] = useState(false);
  //tooltip style properties info icon
  const HtmlTooltip1 = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      fontSize: "8px",
      color: "#495057", // Arrow color
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#495057", // Tooltip background color
      color: "white", // Tooltip text color
      fontSize: "12px", // Tooltip font size
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  }));
  const iProTooltipText = "The ProcID is iProcedures' internal case identifier.  In the iPro Lite mobile app or the Epic linked web app, open the case and scroll to the bottom to find this number.  In the iPro Core app, find it at the bottom of the first screen of Patient Info.";
  useEffect(() => {
    Promise.all([
      GetCaseTypes(),
      GetPatientInvovedTypes(),
      GetFacilityTypes(),
    ]).then((res: any) => {
      if (res[0] !== "") {
        setEventTypeOptions(res[0]);
      }
      if (res[1] !== "") {
        setPatientInvolvedOptions(res[1]);
      }
      if (res[2] !== "") {
        setFacilityOptions(res[2]);
      }
    });
  }, []);

  useEffect(() => {
    if (showPopup) {
      document.body.style.position = "fixed";
    } else {
      document.body.style.position = "absolute";
    }
  }, [showPopup]);

  const GetCaseTypes = () => {
    return new Promise((resolve, reject) => {
      getRequest({ url: "api/EventReport/GetCaseTypes" })
        .then((res) => {
          return resolve(res);
        })
        .catch((e) => {
          return resolve(e);
        });
    });
  };
  const GetPatientInvovedTypes = () => {
    return new Promise((resolve, reject) => {
      getRequest({ url: "api/EventReport/GetPatientInvovedTypes" })
        .then((res) => {
          return resolve(res);
        })
        .catch((e) => {
          return resolve(e);
        });
    });
  };
  const GetFacilityTypes = () => {
    return new Promise((resolve, reject) => {
      getRequest({ url: "api/Site/GetSites" })
        .then((res) => {
          var facilityTypes = res.map((val: any) => {
            return {
              siteName: `${val.siteName} (${val.city}, ${val.state})`,
              siteId: val.siteId,
            };
          });

          return resolve(facilityTypes);
        })
        .catch((e) => {
          return resolve(e);
        });
    });
  };

  const GetMaxDate = () => {
    var dt = new Date();
    // dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
    // var offset = -240; //Timezone offset for EST in minutes.
    // var estDate = new Date(dt.getTime() + offset * 60 * 1000);
    return dt;
  };

  // const toast1 = useRef<Toast>(null);
  const mess = () => {
    // toast1.current?.show({
    //   severity: "success",
    //   summary: "Success",
    //   detail: "Event Created successfully",
    // });
    toast("Event Created successfully", {
      type: "success",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };
  const errormess = () => {
    toast("Something went wrong!", {
      type: "error",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
    // toast1.current?.show({
    //   severity: "error",
    //   summary: "Error!",
    //   detail: "Something wrong happened!",
    // });
  };
  const handleFormChange = (e: any) => {
    let formParams = { ...inputValues } as any;
    formParams[e.target.name] = e.target.value;
    setInputValue(formParams);
    // ERROR VALIDATION
    let errorVal = { ...errValues };
    if (e.target.name === "procedureId") {
      if (formParams.procedureId !== "") {
        if (formParams.procedureId.match("[0-9]+") === null) {
          errorVal["procedureId"] = "iProcedures ProcID must be integer";
        } else if (formParams.procedureId.length < 6) {
          errorVal["procedureId"] = "iProcedures ProcID requires min 6 digits";
        } else if (formParams.procedureId.length > 10) {
          errorVal["procedureId"] =
            "iProcedures ProcID requires max 10 digits";
        } else {
          errorVal["procedureId"] = "";
        }
      } else {
        errorVal["procedureId"] = "";
      }
    } else if (e.target.name === "eventType") {
      if (e.target.name === "eventType") {
        if (formParams.eventType === "") {
          errorVal["eventType"] = "Event Type is required";
        } else {
          errorVal["eventType"] = "";
        }
      }
    } else if (e.target.name === "facility") {
      if (formParams.facility === "") {
        errorVal["facility"] = "Facility is required";
      } else {
        errorVal["facility"] = "";
      }
    } else if (e.target.name === "eventDate") {
      if (formParams.eventDate === undefined) {
        errorVal["eventDate"] = "Event Date is required";
      } else {
        if (isFutureDate(formParams.eventDate)) {
          errorVal["eventDate"] = "Cannot Enter Future Date & Time";
        } else {
          errorVal["eventDate"] = "";
        }
      }
    } else if (e.target.name === "patientInvolved") {
      if (formParams.patientInvolved === "") {
        errorVal["patientInvolved"] = "Patient Involved is required";
      } else {
        errorVal["patientInvolved"] = "";
      }
    }
    setErrValues(errorVal);
  };
  const onSubmit = async () => {
    var utcDate = null;
    var valid = true;
    // ERROR VALIDATION
    let errorVal = { ...errValues };
    if (inputValues.procedureId !== "") {
      if (inputValues.procedureId.match("[0-9]+") === null) {
        valid = false;
        errorVal["procedureId"] = "iProcedures ProcID must be integer";
      } else if (inputValues.procedureId.length < 6) {
        valid = false;
        errorVal["procedureId"] = "iProcedures ProcID requires min 6 digits";
      } else if (inputValues.procedureId.length > 10) {
        valid = false;
        errorVal["procedureId"] = "iProcedures ProcID requires max 10 digits";
      } else {
        errorVal["procedureId"] = "";
      }
    } else {
      errorVal["procedureId"] = "";
    }
    if (inputValues.eventType === "") {
      valid = false;
      errorVal["eventType"] = "Event Type is required";
    } else {
      errorVal["eventType"] = "";
    }
    if (inputValues.facility === "") {
      valid = false;
      errorVal["facility"] = "Facility is required";
    } else {
      errorVal["facility"] = "";
    }
    if (inputValues.eventDate === undefined) {
      valid = false;
      errorVal["eventDate"] = "Event Date is required";
    } else {
      if (isFutureDate(inputValues.eventDate)) {
        valid = false;
        errorVal["eventDate"] = "Cannot Enter Future Date & Time";
      } else {
        errorVal["eventDate"] = "";
      }

      var eventDate = new Date(inputValues.eventDate);
      // const offset = eventDate.getTimezoneOffset() * 60 * 1000;
      // const withOffset = eventDate.getTime();
      // const withoutOffset = withOffset - offset;
      // const newDate = new Date(withoutOffset);
      utcDate = eventDate.toISOString();
    }
    if (inputValues.patientInvolved === "") {
      valid = false;
      errorVal["patientInvolved"] = "Patient Involved is required";
    } else {
      errorVal["patientInvolved"] = "";
    }
    if (inputValues.eventDate !== undefined) {
      if (isFutureDate(inputValues.eventDate)) {
        valid = false;
        errorVal["eventDate"] = "select a valid date and time";
      } else {
        errorVal["eventDate"] = "";
      }
    }
    setErrValues(errorVal);
    if (!valid) {
      setDisable(false);
      return false;
    }

    var reqData = { ...inputValues };
    reqData.eventDate = utcDate;
    reqData.procedureId = reqData.procedureId === "" ? 0 : reqData.procedureId;
    if (reqData.procedureId > 0) {
      var data = await getRequest({
        url: `api/EventReport/IsProcIdDuplicate?procId=${reqData.procedureId}&eventReportId=0`,
      });
      if (data) {
        let errorVal = { ...errValues };
        errorVal["procedureId"] = "iProcedures ProcID already exists";
        setErrValues(errorVal);
        setDisable(false);
        return false;
      }
    }
    if (valid && !data) {
      setSaveLoader(true);
    } else {
      setSaveLoader(false);
    }

    postRequest({ url: "api/EventReport/Create", data: reqData })
      .then((res) => {
        mess();
        // setTimeout(() => {
        setDisable(false);
        setSaveLoader(false);
        resetForm();
        updateModalState();
        redirectEventReport(res);
        // }, 1000);
      })
      .catch((e) => {
        setDisable(false);
        errormess();
        setSaveLoader(false);
        console.log(e);
      });
  };
  const redirectEventReport = (res: any) => {
    navigate("/event/report/edit/" + res, {
      state: {
        eventId: res,
        page: currentPage,
      },
    });
  };

  const resetForm = () => {
    setInputValue({
      procedureId: "",
      eventType: "",
      facility: "",
      eventDate: undefined,
      patientInvolved: "",
      provider: "",
      patientMRN: "",
      patientFirstName: "",
      patientLastName: "",
      event: "",
      classify: "",
      reflect: "",
      userId: null,
      attachment: {
        id: 0,
        attachment: "",
      },
    });
    setErrValues({
      procedureId: "",
      eventType: "",
      facility: "",
      eventDate: "",
      patientInvolved: "",
    });
    setDisable(false);
  };

  const displayPopup = () => {
    setTest(true);
  };

  const hidePopup = () => {
    setTest(false);
  };

  const popupFooter = () => {
    return (
      <>
        <button
          className="buttonCss"
          onClick={() => {
            resetForm();
            updateModalState();
          }}
        >
          Cancel
        </button>
        <button
          className="buttonCss"
          onClick={(e) => {
            console.log(e);
            e.preventDefault();
            setDisable(true);
            onSubmit();
          }}
          disabled={disable}
        >
          Save
        </button>
      </>
    );
  };
  const isFutureDate = (idate: Date) => {
    var today = new Date();
    return today > idate ? false : true;
  };
  if (showPopup) {
    return (
      <>
        {saveLoader ? (
          <>
            <div id="q11">
              <div className="loading">
                <div className="obj"></div>
              </div>
            </div>{" "}
          </>
        ) : null}
        {/* <Toast ref={toast1}></Toast> */}
        <Dialog
          header="Create Event Report"
          visible={showPopup}
          // style={{ width: "90%" }}
          breakpoints={{ "960px": "75vw", "640px": "96vw" }}
          style={{ width: "80vw" }}
          onHide={() => {
            resetForm();
            updateModalState();
          }}
          footer={popupFooter}
        >
          <Divider className="m-0" />
          <form
            style={{
              color: "#495057",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            <Container className="d-flex flex-wrap p-0" fluid={true}>
              <Col lg="3" md="4" sm="6" xs="12" className="mt-2 pt-0 pb-0">
                <Form.Group controlId="formBasicCheckbox">
                  <label>iProcedures ProcID</label>&nbsp;
                  <HtmlTooltip1 title={
                    <div style={{ maxHeight: "100px", overflowY: "auto" }} className="scrollBarTooltip" >
                      {iProTooltipText}
                    </div>
                  }  arrow placement="right" 
                  PopperProps={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, -10],
                        },
                      },
                    ],
                  }}>
                    <i
                      className="pi pi-info-circle"
                      onClick={() => {
                        displayPopup();
                      }}
                    ></i>
                  </HtmlTooltip1>
                  <SummaryInfo test={test} hidePopup={hidePopup} />
                  <InputText
                    style={{ width: "100%" }}
                    name="procedureId"
                    type="number"
                    value={inputValues.procedureId}
                    onChange={handleFormChange}
                    min="1"
                    onKeyDown={(evt) =>
                      ["e", "E", "+", "-"].includes(evt.key) &&
                      evt.preventDefault()
                    }
                  />
                  <p className="err-text mb-0">{errValues.procedureId}</p>
                </Form.Group>
              </Col>
              <Col lg="3" md="4" sm="6" xs="12" className="mt-2 pt-0 pb-0">
                <Form.Group controlId="formBasicCheckbox">
                  <label>
                    Event Type<span style={{ color: "red" }}>*</span>
                  </label>
                  <Dropdown
                    style={{ width: "100%" }}
                    value={inputValues.eventType}
                    options={eventTypeOptions}
                    optionLabel="caseTypeName"
                    optionValue="caseTypeName"
                    name="eventType"
                    onChange={handleFormChange}
                  />
                  <p className="err-text mb-0">{errValues.eventType}</p>
                </Form.Group>
              </Col>
              <Col lg="3" md="4" sm="6" xs="12" className="mt-2 pt-0 pb-0">
                <Form.Group controlId="formBasicCheckbox">
                  <label>
                    Facility<span style={{ color: "red" }}>*</span>
                  </label>
                  <Dropdown
                    style={{ width: "100%" }}
                    value={inputValues.facility}
                    name="facility"
                    onChange={handleFormChange}
                    options={facilityOptions}
                    optionLabel="siteName"
                    optionValue="siteId"
                    filter
                    filterBy="siteName"
                    resetFilterOnHide
                  />
                  <p className="err-text mb-0">{errValues.facility}</p>
                </Form.Group>
              </Col>
              <Col
                lg="3"
                md="4"
                sm="6"
                xs="12"
                className="mt-2 pt-0 pb-0 buttonsize"
              >
                <label>
                  Event Date<span style={{ color: "red" }}>*</span>
                </label>
                <Calendar
                  readOnlyInput
                  style={{ width: "100%" }}
                  name="eventDate"
                  value={inputValues.eventDate}
                  onChange={handleFormChange}
                  className="calender-custom"
                  showTime
                  hourFormat="12"
                  showIcon
                  viewDate={GetMaxDate()}
                  maxDate={GetMaxDate()}
                  hideOnDateTimeSelect={true}
                  dateFormat="mm/dd/yy"
                />
                <p className="err-text mb-0">{errValues.eventDate}</p>
              </Col>
              <Col lg="3" md="4" sm="6" xs="12" className="mt-2 pt-0 pb-0">
                <Form.Group controlId="formBasicCheckbox">
                  <label>
                    Patient Involved<span style={{ color: "red" }}>*</span>
                  </label>
                  <Dropdown
                    style={{ width: "100%" }}
                    value={inputValues.patientInvolved}
                    options={patientInvolvedOptions}
                    optionLabel="patientInvolvedTypeName"
                    optionValue="patientInvolvedTypeName"
                    name="patientInvolved"
                    onChange={handleFormChange}
                  />
                  <p className="err-text mb-0">{errValues.patientInvolved}</p>
                </Form.Group>
              </Col>
              <Col md="12" sm="12" xs="12">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Report Summary
                </span>
              </Col>
              <Col md="12" sm="12" xs="12">
                <p className="m-0">Provider</p>
                <span className="success">No Errors Found</span>
              </Col>
              <Divider className="m-0" />
              {(() => {
                if (inputValues.patientInvolved === "Single Patient") {
                  return (
                    <>
                      <Col className="mt-3" md="12" sm="12" xs="12">
                        <p className="m-0">Patient</p>
                        <span className="success">No Errors Found</span>
                      </Col>
                      <Divider className="m-0" />
                    </>
                  );
                } else {
                  return <></>;
                }
              })()}
              <Col className="mt-3" md="12" sm="12" xs="12">
                <p className="m-0">Event</p>
                <span className="success">No Errors Found</span>
              </Col>
              <Divider className="m-0" />
              <Col className="mt-3" md="12" sm="12" xs="12">
                <p className="m-0">Classify</p>
                <span className="success">No Errors Found</span>
              </Col>
              <Divider className="m-0" />
              <Col className="mt-3" md="12" sm="12" xs="12">
                <p className="m-0">Reflect</p>
                <span className="success">No Errors Found</span>
              </Col>
              <Divider className="m-0" />
              <Col className="mt-3" md="12" sm="12" xs="12">
                <p className="m-0">Attachments</p>
                <span className="success">No Errors Found</span>
              </Col>
            </Container>
          </form>
        </Dialog>
      </>
    );
  } else {
    return <></>;
  }
}
